module.exports = __webpack_public_path__ + "img/testimonial-2-61x61_1testimonial-2-61x61.1b1d3151.png";